import { useMemo } from "react";
import { Autocomplete, Checkbox, TextField } from "@mui/material";

export default function OrderActionSelector({ label, selectableActions, onChange, selection }) {

  const { options, placeholderLabel } = useMemo(
    () => ({
      options: selectableActions
        .filter(n => n.value != "NONE")
        .map(n => ({
          value: n.value,
          label: n.label
        })),
      placeholderLabel: selectableActions
        .find(n => n.value == "NONE")?.label || ""
    }),
    [selectableActions]
  );

  const value = selection ?? [];

  return (
    <Autocomplete
      disableCloseOnSelect
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      multiple
      onChange={(_, newValue) => onChange?.(newValue)}
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={value.length === 0 ? placeholderLabel : ""}
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
      renderOption={(props, option, { selected }) => (
        <li {...props} >
          <Checkbox
            checked={selected}
            size="small"
            sx={{ p: 0.5, mr: 1 }}
          />
          {option.label}
        </li>
      )}
      sx={{
        "& .MuiAutocomplete-option": {
          minHeight: 30,
          py: 0.25,
        },
      }}
      value={value}
    />
  );
}
